import React from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';

import { colors } from '../styles/base';

/*
 * Generated by following this README
 * https://github.com/FormidableLabs/prism-react-renderer/blob/master/tools/themeFromVsCode/README.md
 */
const theme = {
  plain: {
    color: colors.NEAR_WHITE,
    backgroundColor: '#1e1e1e',
  },
  styles: [
    {
      types: ['comment'],
      style: {
        color: 'rgb(154, 155, 153)',
      },
    },
    {
      types: ['string', 'symbol'],
      style: {
        color: 'rgb(154, 168, 58)',
      },
    },
    {
      types: ['number', 'variable'],
      style: {
        color: 'rgb(96, 137, 180)',
      },
    },
    {
      types: ['builtin'],
      style: {
        color: 'rgb(64, 128, 128)',
      },
    },
    {
      types: ['function'],
      style: {
        color: colors.SUN_FLOWER,
      },
    },
    {
      types: ['tag', 'attr-name', 'keyword', 'operator'],
      style: {
        color: colors.LEMON_LIME,
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: colors.SUN_FLOWER,
      },
    },
    {
      types: ['deleted'],
      style: {
        color: 'rgb(220, 50, 47)',
      },
    },
    {
      types: ['changed'],
      style: {
        color: 'rgb(203, 75, 22)',
      },
    },
    {
      types: ['inserted'],
      style: {
        color: 'rgb(33, 145, 134)',
      },
    },
  ],
};

const CodeBlock = ({ children, className }) => {
  const language = className ? className.replace(/language-/, '') : '';
  return (
    <Highlight {...defaultProps} code={children} {...{ language, theme }}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={className}
          style={{ ...style, borderRadius: '4px', padding: '20px 20px 0 20px' }}
        >
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};

export default CodeBlock;
